import { onClickOutside as k, useSwipe as y, SwipeDirection as f } from "@vueuse/core";
import { defineComponent as O, ref as x, computed as d, toRef as S, resolveComponent as C, openBlock as D, createBlock as _, withCtx as b, createElementVNode as u, mergeProps as R, normalizeClass as $, renderSlot as B, createCommentVNode as P } from "vue";
import { usePopoverState as E } from "@onereach/ui-components-common/hooks";
import { O as L } from "./OrOverlay-BjrghiC-.mjs";
import { _ as N } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
var t = /* @__PURE__ */ ((e) => (e.Left = "left", e.Right = "right", e))(t || {});
const T = [
  // Position
  "absolute inset-y-0",
  // Box
  "max-w-[min(360px,100%-theme(spacing.md))]",
  // Spacing
  "px-0",
  "py-sm+",
  // Elevation
  "shadow-modal",
  "dark:shadow-modal-dark",
  // Theme
  "theme-foreground-default",
  "dark:theme-foreground-default-dark",
  "theme-background-default",
  "dark:theme-background-default-dark",
  // Transition
  "transition-transform duration-medium ease-standard"
], V = {
  [t.Left]: [
    // Position
    "start-0",
    // Shape
    "rounded-e-xl"
  ],
  [t.Right]: [
    // Position
    "end-0",
    // Shape
    "rounded-s-xl"
  ]
}, z = [
  // Spacing
  "px-md",
  "py-md"
], A = [
  // Overflow
  "overflow-auto",
  // Box
  "w-full",
  "h-full"
], F = O({
  name: "OrDrawer",
  components: {
    OrOverlay: L
  },
  inheritAttrs: !1,
  props: {
    isOpen: {
      type: Boolean,
      default: !1
    },
    placement: {
      type: String,
      default: () => t.Left
    },
    padding: {
      type: Boolean,
      default: !0
    }
  },
  emits: [
    "update:state",
    "open",
    "close"
  ],
  expose: [
    "root",
    "state",
    "open",
    "close",
    "toggle"
  ],
  setup(e, c) {
    const o = x(), m = d(() => [
      "or-drawer-v3",
      ...T,
      ...V[e.placement],
      ...e.padding ? z : [],
      g.value
    ]), p = d(() => [
      ...A
    ]), { state: r, open: s, close: a, toggle: h } = E(S(e, "isOpen"), c.emit), g = d(() => {
      switch (e.placement) {
        case t.Left:
          return r.value === "closed" ? "-translate-x-[calc(100%+80px)]" : "translate-x-0";
        case t.Right:
          return r.value === "closed" ? "translate-x-[calc(100%+80px)]" : "translate-x-0";
      }
    });
    return k(o, (i) => {
      const n = i.composedPath(), v = ["or-popover-v3", "or-bottom-sheet-v3", "or-modal-v3", "or-confirm-v3"];
      n.some(({ classList: l }) => v.some((w) => l == null ? void 0 : l.contains(w))) || a();
    }), y(o, {
      onSwipeEnd: (i, n) => {
        switch (e.placement) {
          case t.Left:
            n === f.LEFT && a();
            break;
          case t.Right:
            n === f.RIGHT && a();
            break;
        }
      }
    }), {
      root: o,
      rootStyles: m,
      contentStyles: p,
      state: r,
      open: s,
      close: a,
      toggle: h
    };
  }
});
function G(e, c, o, m, p, r) {
  const s = C("OrOverlay");
  return e.state === "open" ? (D(), _(s, {
    key: 0,
    fullscreen: !0
  }, {
    default: b(() => [
      u("div", R(e.$attrs, {
        ref: "root",
        class: e.rootStyles
      }), [
        u("div", {
          class: $(e.contentStyles)
        }, [
          B(e.$slots, "default")
        ], 2)
      ], 16)
    ]),
    _: 3
  })) : P("", !0);
}
const K = /* @__PURE__ */ N(F, [["render", G]]);
export {
  t as D,
  K as O
};
//# sourceMappingURL=OrDrawer-BR0r7GeI.mjs.map
